import React, { useState, useEffect } from "react";
import Translations from "./Translations";
import Logo from "./Logo";
import { Link } from "react-router-dom";


const Header = ({ lang, translations, changeLanguage }) => {

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Verifica si el clic fue fuera del dropdown
      if (!event.target.closest(".dropdown2")) {
        setIsOpen(false);
      }
    };

    // Añadir el listener al documento
    document.addEventListener("click", handleClickOutside);
    return () => {
      // Limpiar el listener cuando el componente se desmonte
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="around width100 header-background">
      <div className="dropdown2">
        {/* Botón principal del dropdown */}
        <Link
          className="dropdown-button2 no-link"
          onClick={toggleDropdown}
        >
          {lang === "ca" ? "CAT" : lang === "es" ? "ESP" : "ENG"}
          <img
            src="img/chevron-down.png"
            alt={translations[lang].chevronalt}
            className="chevron"
          />
        </Link>

        {/* Menú desplegable */}
        {isOpen && (
          <div className="dropdown-menu2">
            <Link
              className={`${lang === "es" ? "blue-bold" : ""} dropdown-item2`}
              to={`?lang=es`}
              onClick={() => {
                changeLanguage("es");
                setIsOpen(false); // Cerrar dropdown
              }}
            >
              ESP
            </Link>
            <Link
              className={`${lang === "ca" ? "blue-bold" : ""} dropdown-item2`}
              to={`?lang=ca`}
              onClick={() => {
                changeLanguage("ca");
                setIsOpen(false); // Cerrar dropdown
              }}
            >
              CAT
            </Link>
            <Link
              className={`${lang === "en" ? "blue-bold" : ""} dropdown-item2`}
              to={`?lang=en`}
              onClick={() => {
                changeLanguage("en");
                setIsOpen(false); // Cerrar dropdown
              }}
            >
              ENG
            </Link>
          </div>
        )}
      </div>
      {/* {!isDeviceMobile && ( */}
        <Logo
          img={"img/logos/faro_blanco_sin_letras.png"}
          alt={translations[lang].logoalt}
        />
      {/* )} */}
      <Translations
        lang={lang}
        translations={translations}
        changeLanguage={changeLanguage}
      />
    </div>
  );
};

export default Header;
